import React, { useReducer } from "react";
import ModuleDisplayTimeAgo from "../../../../UI/modules/fieldsDisplay/ModuleDisplayTimeAgo";
import { BsCheckAll, BsTrash } from "react-icons/bs";
import { listingInitialState, listingReducer } from "../../../partner/reducers/listingReducer";
import axios from "../../../../../config/axios";
import useConfirm from "../../../../../HOC/custom/useConfirm";
import moduleConfig from "../../moduleConfig";
import { toastNotification } from "../../../../../config/toastNotification";
import { Store as toast } from "react-notifications-component";
const AdminMessageItem = ({ message, loadItems }) => {
  const [listingState, listingDispatch] = useReducer(
    listingReducer,
    listingInitialState
  );
  const { confirm } = useConfirm();
  const confirmAndDelete = async (id) => {
    const isConfirmed = await confirm(
      `Do you really want to delete this message?`
    );

    if (isConfirmed) {
      await deleteItem(id);
    }
  };

  const deleteItem = async (id) => {
    console.log("In block Item Function");
    listingDispatch({
      type: "BLOCK_REQUEST",
    });

    try {
      const res = await axios.delete(`${moduleConfig.url}/${message.conversationId}/${message._id}`);

      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Message deleted successfully.`,
        type: "success",
      });
      loadItems();
    } catch (error) {
      console.log(error)
      listingDispatch({
        type: "BLOCK_FAILURE",
        payload: error,
      });

      setTimeout(() => {
        listingDispatch({
          type: "REMOVE_ERROR",
        });
      }, 5000);
    }
  };
  return (
    <div className="direct-chat-msg right">
      {/* <img className="direct-chat-img" src="/docs/3.1//assets/img/user3-128x128.jpg" alt="message user image"> */}

      <div className="direct-chat-text float-right text-right">
      {message.isDeleted ==="1"?<span className="deletedMessage">You deleted this message</span>:<>
        <div className="direct-chat-infos clearfix">
          <span className="direct-chat-name text-purple float-left">You</span>
          <div
            onClick={confirmAndDelete}
            className="direct-chat-timestamp text-secondary fs-10 float-right"
            aria-label="Delete message"
          >
            <BsTrash />
          </div>
        </div>
        {message.message}
        <p className="direct-chat-timestamp chatTime fs-10 text-right mb-0">
          {message.createdAt}
          {""}
          {message.isRead === 1 || message.isRead === "1" || message.isRead === true ? (
            <BsCheckAll className="readMessage ms-1" />
          ) : (
            <BsCheckAll className="unreadMessage ms-1" />
          )}
        </p>
        </>}
      </div>
    </div>
  );
};

export default AdminMessageItem;
